// extracted by css-extract-rspack-plugin
export default {"bui-Text":"evZaZmKCqa8JmBFN"};